<div class="selector-container p-block optional-padding smart-camera-block" [ngClass]="showSidebar ? 'd-none' : ''">
  <div class="flex-container m-camera" #container>
    <header *ngIf="(header.question || header.showSubtitle || header.showSubtitleInfo || header.showAddonTitle)">
      <div class="row" *ngIf="header.showAddonTitle">
        <div class="p-x-page p-x-page-thermo">
          <h6 class="m-y-0 addon-title" [innerHTML] = "header.addonTitle | translate"></h6>
        </div>
      </div>
        <div class="row" *ngIf="header.question">
          <div class="p-x-page p-t-page-title p-x-page-thermo">
            <h1 class="m-y-0" [innerHTML]= "header.question | translate"></h1>
          </div>
        </div>
        <div class="row d-flex p-x-page m-subtitle align-items-center p-x-page-thermo" *ngIf="header.showSubtitle"
        >
          <div class="d-inline-flex"
            *ngIf="header.showSubtitle"
          >
            <div>
              <h6 class="font-weight-normal m-y-0" [innerHTML]="header.subtitle | translate"></h6>
            </div>
          </div>
        </div>
    </header>

    <div *ngFor="
      let entry of dataEntriesSmartCamera;
      let indexOfelement=index;
      let isFirst = first;
      let isLast = last;
      "
    >
        <app-spinner
          class="smart-camera row-item"
          [id]="entry.ID"
          [value]="entry.quantity"
          [title]="entry.name | translate"
          [tooltip]="entry.description | translate"
          [showTooltip]="true"
          [min]="1"
          [max]="1"
          [ngClass]="{
                        'p-t-25': indexOfelement != 0 && indexOfelement != 1,
                        'first': isFirst,
                        'last': isLast,
                        'evidence' : entry.quantity > 0
                      }"
          [showInfoButton]="true"
          [lateralPanelId]="'lateral-'+entry.ID"
          [lateralPanelTitle]="entry.lateralPanelTitle | translate"
          [price]="entry.price"
          [showPrice]="true"
          [image]="entry.image"
          [included]="entry.included"
          (onSpinnerUpd)="onIUSpinnerUpd($event, entry.ID)"
        >
          <!--[lateralPanelId]="'lateral-'+indexOfelement"-->
      </app-spinner>
    </div>
  </div>

  <div class="flex-container m-addon" #container2>

    <div class="row">
      <div class="addon-header" [innerHTML] = "'b2c.IDS_ADDON_HEADER_CAMERA' | translate"></div>
    </div>

    <div *ngFor="
      let entry of addOnDataEntriesSmartCamera;
      let indexOfelement=index;
      let isFirst = first;
      let isLast = last;
      "
      class="addon-element"
    >
        <app-spinner
          class="smart-camera-addon row-item row-item-addon"
          [id]="entry.ID"
          [value]="entry.quantity"
          [title]="entry.name | translate"
          [tooltip]="entry.description | translate"
          [showTooltip]="true"
          [min]="0"
          [ngClass]="{
                        'p-t-25': indexOfelement != 0 && indexOfelement != 1,
                        'first': isFirst,
                        'last': isLast,
                        'evidence' : entry.quantity > 0
                      }"
          [lateralPanelId]="'lateral-'+entry.ID"
          [lateralPanelTitle]="entry.lateralPanelTitle | translate"
          [showInfoButton]="true"
          [price]="entry.price"
          [showPrice]="true"
          [image]="entry.image"
          [included]="entry.included"
          (onSpinnerUpd)="onIUSpinnerUpdAddon($event, entry.ID)"
        >
      </app-spinner>
    </div>
  </div>
</div>

<app-lateral-panel *ngFor="
let entry of getAllComponent();
let indexOfelement=index;"
id="lateral-{{entry.ID}}"
class="subtitle-info-lateral primary accordion"
  [extraClasses]="'m-w-768'" [(showSidebar)]="showSidebar">
  <div class="row d-flex justify-content-between align-items-center button-row exit-row panel-title">
    <h3 class="primary m-b-question m-t-question p-y" [innerHTML]="entry.lateralPanelTitle | translate"></h3>
    <button
      mat-flat-button
      class="bticino-ico close round-button-with-background transparent-background"
      style="width: 40px; height: 40px"
      (click)="onCloseTooltip()"
    >
    </button>
  </div>
  <p class="primary m-b-32 p-r-29 m-t-0 p-y panel-description" [innerHTML]="entry.lateralPanelDescription | translate"></p>
  <div class="p-x-23 p-t-video p-b-video lateral-panel-media" *ngIf="entry.videoUrl">
    <video width="100%" controls [autoplay]="false" [muted]="true" class="lateral-panel-video">
      <source [src]="entry.videoUrl" type="video/mp4">
      {{'b2c.IDS_IU_POPUP_VIDEO_ERROR' | translate}}
    </video>
  </div>
  <div *ngIf="entry.lateralPanelImage" class="lateral-panel-media">
    <img [src]="entry.lateralPanelImage" class="lateral-panel-image">
  </div>
</app-lateral-panel>